import { useConfig } from "@jti/app-context/useConfig";

import { WebPushNotificationsAutoPromptController } from "./WebPushNotificationsAutoPromptController";

type WebPushNotificationsProps = {
  pathname?: string;
};

export const WebPushNotifications = ({ pathname }: WebPushNotificationsProps) => {
  const { isFirebaseEnabled = false } = useConfig();

  if (!isFirebaseEnabled) {
    return null;
  }

  return <WebPushNotificationsAutoPromptController pathname={pathname} />;
};
